import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const permeability = {
    jpath: ['spectra', 'permeability'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default permeability;
//# sourceMappingURL=permeability.js.map